
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../node_modules/vue-loader/lib/style-rewriter?id=data-v-b0db2f30!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Header.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./Header.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-b0db2f30!../../node_modules/vue-loader/lib/selector?type=template&index=0!./Header.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/Header.vue
// module id = 76
// module chunks = 0